const buildToolkitUrl = (tenantKey, stage, tld, excludeProtocol = false) => {
  const baseUrl = stage === 'live' ? `${tenantKey}.mindtools.com` : `${tenantKey}.${stage}.${tld}`
  return `${excludeProtocol ? '' : 'https://'}${baseUrl}`
}

export {
  buildToolkitUrl
}
